import { apiClient } from "./apiClient";
import apiUltils from "./apiUltils";

export default {
  findByOrg(params, category) {
    var param = "";
    if (category) param = `?category=${category}`;
    return apiClient.get(`/rest/channels/org/${params}${param}`);
  },

  findByOrgAndCategories(params, categories) {
    console.log("findByOrgAndCategories categories", categories);
    return apiClient.post(
      `/rest/channels/categories/org/${params}`,
      categories,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  findOne(params) {
    return apiClient.get(`/rest/channels/${params}`);
  },

  getLastDataChannelsOfDevice(params) {
    return apiClient.get(`rest/channels/data/device/${params.id}`);
  },

  pushData(params) {
    return apiClient.post(
      `/rest/channels/pushData/device/${params.id}/channel/${params.channelId}`,
      params.data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getDataByDeviceAndChannel(params, cancelToken) {
    return apiClient.get(
      apiUltils.buildParamsListURI(`/rest/channels/device/`, params),
      {
        cancelToken: cancelToken,
      }
    );
  },

  create(params) {
    return apiClient.post(`/rest/channels`, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  update(id, params) {
    return apiClient.put(`/rest/channels/${id}`, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  delete(id) {
    return apiClient.delete(`/rest/channels/${id}`);
  },

  deleteData(id, deviceId) {
    return apiClient.delete(`/rest/channels/${id}/data/${deviceId}`);
  },
};
